import { mapActions, mapMutations } from 'vuex'

const Menu = {

  data: ()=>({
    autoClose: true,
    menuTree: []
  }),

  computed:
  {
    currentMenu()
    {
      return this.selectedMenu ? this.selectedMenu : this.menu
    },

    selectedMenu()
    {
      return this.menuTree.length > 0 ? this.menuTree[ this.menuTree.length-1 ] : null
    }
  },

  methods:
  {
    ...mapActions({
      goToMenu: 'menu/open'
    }),

    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    openMenu(item)
    {
      // menu is disabled?
      if( item.disabled )
          return

      // submenu?
      if( item.hasChildren )
      {
        this.autoClose = false

        this.menuTree.push(item.children)
          
        return
      }

      if( !item.isOpen )
        this.setLoading('linear')

      this.goToMenu(item)
    },

    back()
    {
      this.menuTree.pop()

      if( this.menuTree.length === 0 )
        window.setTimeout(()=>this.autoClose = true, 100)
    }
  }
}

export default Menu